import styled from "styled-components";
import NowNext from "./NowNext";
import theme from "../../styles/theme";


import ScheduleList2 from "./detail/ScheduleList2";
import Notice from "./Notice2";
import moment from "moment";
import Moment from "react-moment";
import StatusCards from "./StatusCards";


const MainWrap = styled.div`
    width: 100%;
    // height: 100vh;
    // overflow: hidden;
    padding: 0.5rem 0.5rem;
    box-sizing: border-box;
    background: #ffffff;
`;

const MainTitleLine = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    // border: 1px solid red;
    box-sizing: border-box;
`;

const MainTitle = styled.span`
    height: 2.25rem;
    line-height: 2.25rem;
    font-size: 2.25rem;
    font-weight: bold;
`;

const ScrollWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    // margin-top: 1rem;
    height: 100%;
    // min-height: calc(100% - 3rem);
    // overflow: scroll;
    box-sizing: border-box;
    // border: 1px solid red;
`;

const CardLine = styled.div`
    width: 100%;
    height: 6rem;
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr;
    gap: 1rem;
    box-sizing: border-box;
    // border: 1px solid red;
`;

const ScheduleLine = styled.div`
    flex-grow: 1;
    width: 100%;
    box-sizing: border-box;
    // border: 1px solid red;
`;

const NoticeLine = styled.div`
    width: 100%;
    height: 10rem;
    min-height: 10rem;
    // border: 1px solid red;
    box-sizing: border-box;
    // margin-bottom: 16px;
`
const FullMode = () => {

    return (
        <MainWrap>
            <MainTitleLine>
                <MainTitle>DASHBOARD</MainTitle>
                <span style={{fontSize:'2rem'}}><Moment interval={(60000)*60} format={'YYYY-MM-DD(ddd)'} /></span>
            </MainTitleLine>
            <ScrollWrap>
                <CardLine>
                    <StatusCards />
                </CardLine>
                <ScheduleLine>
                    <ScheduleList2 />
                </ScheduleLine>
                <NoticeLine>
                    <Notice />
                </NoticeLine>
            </ScrollWrap>
        </MainWrap>
    )

}

const Card = styled.div`
    // border: 1px solid red;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #e8e7de;
    height: 100%;
    max-height: 6rem;
`;

const CardMarkArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.3rem;
`;

const CardMark = styled.div`
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
`

export default FullMode;